module.exports = __webpack_public_path__ + "img/logoWMobily.c51e6b07.svg";